var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".k{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "k",
    d: "m32.7891,5.5H7.5c-1.1046,0-2,.8954-2,2v33c0,1.1046.8954,2,2,2h33c1.1046,0,2-.8954,2-2V14.0625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "k",
    d: "m42.8918,3.4917h-9.3202c-.312,0-.5649.2529-.5649.5649v9.3202c0,.312.2529.5649.5649.5649h9.3202c.312,0,.5649-.2529.5649-.5649V4.0566c0-.312-.2529-.5649-.5649-.5649Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "k",
    d: "m5.5151,35.5209s4.0371-2.8561,6.2361-3.9669c1.5351-.7754,3.0978-1.9963,4.8122-1.8605,1.85.1465,3.0505,2.2161,4.8121,2.7997.8317.2756,1.7439.4164,2.6118.2962,1.0368-.1437,2.0194-.6333,2.9065-1.1888,2.2286-1.3957,3.6603-3.8468,5.8746-5.2652.7908-.5065,1.6472-1.0751,2.5853-1.1195,2.4131-.1142,4.5188,1.9857,6.8927,2.239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "g",
    className: "k",
    cx: 13.9796,
    cy: 13.2526,
    r: 3.9659
  }), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "k",
    d: "m36.4118,8.2098l1.8177-1.8177v4.6599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    className: "k",
    d: "m40.0517,8.1989l-1.8177-1.8177v4.6599"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMan);
export default __webpack_public_path__ + "static/media/defaultMan.7b74aa0a0af8eb77ee67c7c6b0c14f05.svg";
export { ForwardRef as ReactComponent };